<template>
  <div v-if="fieldData.field_name" class="field-input-checkbox form-group">
    <div class="custom-control custom-checkbox smaller-font-content">
      <input
        type="checkbox"
        :disabled="(!!showDisabled())"
        :ref="fieldData.field_name"
        :id="fieldData.field_name"
        :name="fieldData.field_name"
        v-model="fieldData.field_value"
        v-validate="fieldData.rules"
        v-bind:class="{ 'custom-control-input': true,
          'error': errors.has(fieldData.field_name) }">

        <label :for="fieldData.field_name" class="custom-control-label">{{ fieldData.label }}</label>
    </div>

    <div class="invalid-feedback d-block">{{ errors.first(fieldData.field_name) }}</div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData'],
  methods: {
    showDisabled() {
      return !this.fieldData.is_enabled;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/interactive/InputCheckbox.vue?54474787